import DividerSelectPhotoSection from './DividerSelectPhotoSection';

export default DividerSelectPhotoSection;
